import { render, staticRenderFns } from "./OrdersWithKids.vue?vue&type=template&id=6e61a5c0"
import script from "./OrdersWithKids.vue?vue&type=script&lang=js"
export * from "./OrdersWithKids.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports